import { render, staticRenderFns } from "./epb-modal-dialog.component.vue?vue&type=template&id=b59c19a4&scoped=true"
import script from "./epb-modal-dialog.component.vue?vue&type=script&lang=ts"
export * from "./epb-modal-dialog.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-modal-dialog.component.vue?vue&type=style&index=0&id=b59c19a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59c19a4",
  null
  
)

export default component.exports